export const MIME_TYPES: Record<string, string> = {
  pdf: 'application/pdf',
  zip: 'application/zip',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  png: 'image/png',
  txt: 'text/plain',
  csv: 'text/csv',
  json: 'application/json',
};
